//器官女
const allOrgan = {
  woman_arr: [
    {
      icon: "eye_left",
      name: "左眼",
      top:50,
      left:50
    },
    {
      icon: "eye_right",
      name: "右眼",
      top:210,
      left:455
    },
    {
      icon: "ear_left",
      name: "左耳",
      top:210,
      left:455
    },
    {
      icon: "ear_right",
      name: "右耳",
      top:210,
      left:455
    },
    {
    icon: "heart",
    name: "心脏",
    top:390,
    left:455,
  },
  {
    icon: "brain_left",
    name: "左脑",
    top:210,
    left:455
  },
  {
    icon: "brain_right",
    name: "右脑",
    top:210,
    left:50
  },
  {
    icon: "lung_left",
    name: "左肺",
    top:380,
    left:470
  },
  {
    icon: "lung_right",
    name: "右肺",
    top:380,
    left:40
  },
  {
    icon: "liver",
    name: "肝",
    top:465,
    left:40
  },
  {
    icon: "kidney_left",
    name: "左肾",
    top:485,
    left:455
  },
  {
    icon: "kidney_right",
    name: "右肾",
    top:485,
    left:55
  },
  {
    icon: "stomach",
    name: "胃",
    top:450,
    left:455,
  },
  {
    icon: "eye_left",
    top:233,
    left:450
  },
  {
    icon: "eye_right",
    top:233,
    left:50
  },
  {
    icon: "intestine_12",
    top:490,
    left:420
  },
  {
    icon: "intestine_xiao",
    top:560,
    left:90
  },
  {
    icon: "intestine_da",
    top:540,
    left:465
  },
  {
    icon: "spleen",
    top:440,
    left:480,
  },
  {
    icon: "gallbladder",
    top:460,
    left:40
  },
  {
    icon: "pancreas",
    top:490,
    left:90
  },
  {
    icon: "andrology_q",
    top:635,
    left:85
  },
  {
    icon: "andrology_left",
    top:625,
    left:475
  },
  {
    icon: "andrology_right",
    top:625,
    left:25
  },
  {
    icon: "thyroid",
    top:315,
    left:433
  },
  {
    icon: "trachea_q",
    top:315,
    left:80
  },
  {
    icon: "trachea_z",
    top:365,
    left:75
  },
  {
    icon: "nose_left",
    top:251,
    left:434
  },
  {
    icon: "nose_right",
    top:251,
    left:68
  },
  {
    icon: "tonsil_left",
    top:270,
    left:455
  },
  {
    icon: "tonsil_right",
    top:270,
    left:50
  },
  {
    icon: "knee_left",
    top:830,
    left:463
  },
  {
    icon: "knee_right",
    top:830,
    left:40
  },
  {
    icon: "shoulder_left",
    top:355,
    left:500
  },
  {
    icon: "shoulder_right",
    top:355,
    left:0
  },
  {
    icon: "bladder",
    top:660,
    left:85
  },
  {
    icon: "adrenal",
    top:445,
    left:60
  },
  {
    icon: "breast_left",
    top:400,
    left:480
  },
  {
    icon: "breast_right",
    top:400,
    left:35
  },
  {
    icon: "ear_left",
    top:245,
    left:455
  },
  {
    icon: "ear_right",
    top:260,
    left:30
  },
  {
    icon: "upper_left",
    top:465,
    left:520
  },
  {
    icon: "upper_right",
    top:465,
    left:0
  },
  {
    icon: "the_da_left",
    top:750,
    left:480
  },
  {
    icon: "the_da_right",
    top:750,
    left:28
  },
  {
    icon: "the_xiao_left",
    top:950,
    left:470
  },
  {
    icon: "the_xiao_right",
    top:950,
    left:40
  },
  {
    icon: "hip_left",
    top:600,
    left:490
  },
  {
    icon: "hip_right",
    top:600,
    left:15
  },
  {
    icon: "gullet",
    top:320,
    left:75
  },
  {
    icon: "throat",
    top:290,
    left:85
  },
  {
    icon: "carotid_left",
    top:285,
    left:440
  },
  {
    icon: "carotid_right",
    top:285,
    left:50
  },
  ],
  //器官男
  man_arr: [{
    icon: "heart",
    name: "心脏",
    top:375,
    left:455,
  },
  {
    icon: "brain_left",
    name: "左脑",
    top:210,
    left:445
  },
  {
    icon: "brain_right",
    name: "右脑",
    top:210,
    left:60
  },
  {
    icon: "lung_left",
    name: "左肺",
    top:360,
    left:470
  },
  {
    icon: "lung_right",
    name: "右肺",
    top:360,
    left:40
  },
  {
    icon: "liver",
    name: "肝",
    top:440,
    left:40
  },
  {
    icon: "kidney_left",
    name: "左肾",
    top:460,
    left:455
  },
  {
    icon: "kidney_right",
    name: "右肾",
    top:460,
    left:55
  },
  {
    icon: "stomach",
    name: "胃",
    top:430,
    left:455,
  },
  {
    icon: "eye_left",
    top:233,
    left:450
  },
  {
    icon: "eye_right",
    top:233,
    left:55
  },
  {
    icon: "intestine_12",
    top:475,
    left:420
  },
  {
    icon: "intestine_xiao",
    top:540,
    left:90
  },
  {
    icon: "intestine_da",
    top:540,
    left:465
  },
  {
    icon: "spleen",
    top:420,
    left:480,
  },
  {
    icon: "gallbladder",
    top:460,
    left:40
  },
  {
    icon: "pancreas",
    top:475,
    left:90
  },
  {
    icon: "andrology_q",
    top:610,
    left:85
  },
  {
    icon: "andrology_left",
    top:595,
    left:450
  },
  {
    icon: "andrology_right",
    top:595,
    left:55
  },
  {
    icon: "thyroid",
    top:315,
    left:433
  },
  {
    icon: "trachea_q",
    top:315,
    left:80
  },
  {
    icon: "trachea_z",
    top:365,
    left:75
  },
  {
    icon: "nose_left",
    top:251,
    left:434
  },
  {
    icon: "nose_right",
    top:251,
    left:68
  },
  {
    icon: "tonsil_left",
    top:270,
    left:455
  },
  {
    icon: "tonsil_right",
    top:270,
    left:50
  },
  {
    icon: "knee_left",
    top:900,
    left:463
  },
  {
    icon: "knee_right",
    top:900,
    left:40
  },
  {
    icon: "shoulder_left",
    top:351,
    left:500
  },
  {
    icon: "shoulder_right",
    top:351,
    left:0
  },
  {
    icon: "bladder",
    top:625,
    left:85
  },
  {
    icon: "adrenal",
    top:445,
    left:60
  },
  {
    icon: "breast_left",
    top:400,
    left:35
  },
  {
    icon: "breast_right",
    top:400,
    left:480
  },
  {
    icon: "ear_left",
    top:245,
    left:455
  },
  {
    icon: "ear_right",
    top:245,
    left:40
  },
  {
    icon: "upper_left",
    top:420,
    left:520
  },
  {
    icon: "upper_right",
    top:420,
    left:0
  },
  {
    icon: "the_da_left",
    top:700,
    left:480
  },
  {
    icon: "the_da_right",
    top:700,
    left:28
  },
  {
    icon: "the_xiao_left",
    top:900,
    left:470
  },
  {
    icon: "the_xiao_right",
    top:900,
    left:40
  },
  {
    icon: "hip_left",
    top:580,
    left:490
  },
  {
    icon: "hip_right",
    top:580,
    left:15
  },
  {
    icon: "gullet",
    top:320,
    left:75
  },
  {
    icon: "throat",
    top:290,
    left:85
  },
  {
    icon: "carotid_left",
    top:285,
    left:440
  },
  {
    icon: "carotid_right",
    top:285,
    left:70
  },
  ],
  //脊椎
  vertebra: [ {
    icon: "neck_1",
    top: 254,
    left: 20
  }, {
    icon: "neck_2",
    top: 280,
    left: 440
  }, {
    icon: "neck_3",
    top: 290,
    left: 15
  }, {
    icon: "neck_4",
    top: 300,
    left: 440
  }, {
    icon: "neck_5",
    top: 325,
    left: 15
  }, {
    icon: "neck_6",
    top: 322,
    left: 445
  }, {
    icon: "neck_7",
    top: 365,
    left: 20
  }, {
    icon: "chest_1",
    top: 355,
    left: 460
  }, {
    icon: "chest_2",
    top: 402,
    left: 25
  }, {
    icon: "chest_3",
    top: 400,
    left: 468
  }, {
    icon: "chest_4",
    top: 435,
    left: 25
  }, {
    icon: "chest_5",
    top: 445,
    left: 480
  }, {
    icon: "chest_6",
    top: 480,
    left: 30
  }, {
    icon: "chest_7",
    top: 495,
    left: 485
  }, {
    icon: "chest_8",
    top: 515,
    left: 30
  }, {
    icon: "chest_9",
    top: 553,
    left: 490
  }, {
    icon: "chest_10",
    top: 565,
    left: 25
  }, {
    icon: "chest_11",
    top: 613,
    left: 485
  }, {
    icon: "chest_12",
    top: 615,
    left: 20
  }, {
    icon: "waist_1",
    top: 675,
    left: 480
  }, {
    icon: "waist_2",
    top: 685,
    left: 20
  }, {
    icon: "waist_3",
    top: 735,
    left: 475
  }, {
    icon: "waist_4",
    top: 758,
    left: 15
  }, {
    icon: "waist_5",
    top: 790,
    left: 480
  }, {
    icon: "sacral_1",
    top: 820,
    left: 15
  }, {
    icon: "sacral_2",
    top: 840,
    left: 475
  }, {
    icon: "sacral_3",
    top: 855,
    left: 15
  }, {
    icon: "sacral_4",
    top: 870,
    left: 480
  }, {
    icon: "sacral_5",
    top: 885,
    left: 15
  }, {
    icon: "tail",
    top: 930,
    left: 480
  }]
}
const risk = {
  //器官女
woman_arr: [{
  icon: "heart",
  name: "心脏",
  top: 575,
  left: 455,
},
{
  icon: "carotid",
  name: "颈动脉",
  top: 575,
  left:455,
},
{
  icon: "brain_left",
  name: "左脑",
  top: 430,
  left: 445
},
{
  icon: "blood",
  name: "血管",
  top: 870,
  left: 10
},
{
  icon: "brain_right",
  name: "右脑",
  top: 430,
  left:60
},
{
  icon: "lung_left",
  name: "左肺",
  top: 560,
  left:470
},
{
  icon: "lung_right",
  name: "右肺",
  top: 560,
  left:40
},
{
  icon: "liver",
  name: "肝",
  top: 640,
  left:40
},
{
  icon: "kidney_left",
  name: "左肾",
  top: 660,
  left:455
},
{
  icon: "kidney_right",
  name: "右肾",
  top: 660,
  left:55
},
{
  icon: "lumbosacral_left",
  name: "腰",
  top: 680,
  left: 15
},
{
  icon: "ovary",
  name: "卵巢",
  top: 780,
  left: 35
},
{
  icon: "stomach",
  name: "胃",
  top: 630,
  left:455,
},
{
  icon: "eye_left",
  top: 233,
  left:450
},
{
  icon: "eye_right",
  top:233,
  left:55
},
{
  icon: "intestine_12",
  top:475,
  left:420
},
{
  icon: "intestine_xiao",
  top:540,
  left:90
},
{
  icon: "intestine_da",
  top: 740,
  left:465
},
{
  icon: "spleen",
  top: 620,
  left:480,
},
{
  icon: "gallbladder",
  top: 660,
  left:40
},
{
  icon: "pancreas",
  top: 675,
  left:90
},
{
  icon: "andrology",
  top: 810,
  left: 75
},
{
  icon: "andrology_q",
  top: 590,
  left:85
},
{
  icon: "andrology_left",
  top: 595,
  left:450
},
{
  icon: "andrology_right",
  top:595,
  left:55
},
{
  icon: "thyroid",
  top:315,
  left:433
},
{
  icon: "trachea_q",
  top:315,
  left:80
},
{
  icon: "trachea_z",
  top:365,
  left:75
},
{
  icon: "trachea",
  top: 515,
  left:80
},
{
  icon: "nose_left",
  top:251,
  left:434
},
{
  icon: "nose_right",
  top:251,
  left:68
},
{
  icon: "tonsil_left",
  top:270,
  left:455
},
{
  icon: "tonsil_right",
  top:270,
  left:50
},
{
  icon: "knee_left",
  top: 1010,
  left:463
},
{
  icon: "knee_right",
  top: 1010,
  left:40
},
{
  icon: "shoulder_left",
  top:351,
  left:500
},
{
  icon: "shoulder_right",
  top:351,
  left:0
},
{
  icon: "bladder",
  top:625,
  left:85
},
{
  icon: "adrenal",
  top: 645,
  left:60
},
{
  icon: "breast_left",
  top: 600,
  left:35
},
{
  icon: "breast_right",
  top: 600,
  left:480
},
{
  icon: "ear_left",
  top:245,
  left:455
},
{
  icon: "ear_right",
  top:245,
  left:40
},
{
  icon: "upper_left",
  top:420,
  left:520
},
{
  icon: "upper_right",
  top:420,
  left:0
},
{
  icon: "the_da_left",
  top:700,
  left:480
},
{
  icon: "the_da_right",
  top:700,
  left:28
},
{
  icon: "the_xiao_left",
  top:900,
  left:470
},
{
  icon: "the_xiao_right",
  top:900,
  left:40
},
{
  icon: "hip_left",
  top:580,
  left:490
},
{
  icon: "hip_right",
  top:580,
  left:15
},
{
  icon: "gullet",
  top: 520,
  left:75
},
{
  icon: "throat",
  top: 490,
  left:85
},
{
  icon: "carotid_left",
  top:285,
  left:440
},
{
  icon: "carotid_right",
  top:285,
  left:70
},
],
//器官男
man_arr: [{
  icon: "heart",
  name: "心脏",
  top: 575,
  left:455,
},
{
  icon: "brain_left",
  name: "左脑",
  top: 410,
  left:445
},
{
  icon: "brain_right",
  name: "右脑",
  top: 410,
  left:60
},
{
  icon: "blood",
  name: "血管",
  top: 870,
  left: 10
},
{
  icon: "lymph",
  name: "淋巴",
  top: 490,
  left: 14
},
{
  icon: "lymph_left",
  name: "左淋巴",
  top: 450,
  left: 10
},
{
  icon: "lymph_right",
  name: "右淋巴",
  top: 450,
  left: 10
},
{
  icon: "lung_left",
  name: "左肺",
  top: 560,
  left:470
},
{
  icon: "lung_right",
  name: "右肺",
  top: 560,
  left:40
},
{
  icon: "liver",
  name: "肝",
  top: 640,
  left:40
},
{
  icon: "kidney_left",
  name: "左肾",
  top: 660,
  left:455
},
{
  icon: "kidney_right",
  name: "右肾",
  top: 660,
  left:55
},
{
  icon: "lumbosacral_left",
  name: "腰",
  top: 715,
  left: 10
},
{
  icon: "stomach",
  name: "胃",
  top: 630,
  left:455,
},
{
  icon: "eye_left",
  top: 233,
  left: 450
},
{
  icon: "eye_right",
  top:233,
  left:55
},
{
  icon: "intestine_12",
  top:475,
  left:420
},
{
  icon: "intestine_xiao",
  top:540,
  left:90
},
{
  icon: "intestine_da",
  top: 740,
  left:465
},
{
  icon: "spleen",
  top: 6420,
  left:480,
},
{
  icon: "gallbladder",
  top:460,
  left:40
},
{
  icon: "pancreas",
  top: 675,
  left:90
},
{
  icon: "andrology",
  top: 810,
  left:85
},
{
  icon: "andrology_q",
  top: 610,
  left:85
},
{
  icon: "andrology_left",
  top: 595,
  left:450
},
{
  icon: "andrology_right",
  top: 595,
  left:55
},
{
  icon: "thyroid",
  top:315,
  left:433
},
{
  icon: "trachea_q",
  top: 315,
  left:80
},
{
  icon: "trachea",
  top: 515,
  left:80
},
{
  icon: "trachea_z",
  top:365,
  left:75
},
{
  icon: "nose_left",
  top:251,
  left:434
},
{
  icon: "nose_right",
  top:251,
  left:68
},
{
  icon: "tonsil_left",
  top:270,
  left:455
},
{
  icon: "tonsil_right",
  top:270,
  left:50
},
{
  icon: "knee_left",
  top: 1010,
  left: 463
},
{
  icon: "knee_right",
  top: 1010,
  left:40
},
{
  icon: "shoulder_left",
  top:351,
  left:500
},
{
  icon: "shoulder_right",
  top:351,
  left:0
},
{
  icon: "bladder",
  top:625,
  left:85
},
{
  icon: "adrenal",
  top:445,
  left:60
},
{
  icon: "breast_left",
  top:400,
  left:35
},
{
  icon: "breast_right",
  top:400,
  left:480
},
{
  icon: "ear_left",
  top:245,
  left:455
},
{
  icon: "ear_right",
  top:245,
  left:40
},
{
  icon: "upper_left",
  top:420,
  left:520
},
{
  icon: "upper_right",
  top:420,
  left:0
},
{
  icon: "the_da_left",
  top:700,
  left:480
},
{
  icon: "the_da_right",
  top:700,
  left:28
},
{
  icon: "the_xiao_left",
  top:900,
  left:470
},
{
  icon: "the_xiao_right",
  top:900,
  left:40
},
{
  icon: "hip_left",
  top:580,
  left:490
},
{
  icon: "hip_right",
  top:580,
  left:15
},
{
  icon: "gullet",
  top: 520,
  left:75
},
{
  icon: "throat",
  top: 490,
  left:85
},
{
  icon: "carotid_left",
  top:285,
  left:440
},
{
  icon: "carotid_right",
  top:285,
  left:70
},
],

}
module.exports = {
  allOrgan_woman_arr: allOrgan.woman_arr,
  allOrgan_man_arr: allOrgan.man_arr,
  allOrgan_vertebra: allOrgan.vertebra,
  risk_woman_arr: risk.woman_arr,
  risk_man_arr: risk.man_arr,
}